// ── Zentrale Kontaktdaten ──────────────────────────────
// Hier ändern → wird überall im System übernommen

export const KONTAKT = {
  telefon:        "05364 8960029",       // Anzeige-Format
  telefonHref:    "tel:+4953648960029",  // Format für tel:-Links
  telefonDatum:   "053648960029",        // Format für Datenschutz-Text
  fax:            "05364 8960038",
  email:          "kontakt@milchbauernhof.de",
  emailObfusk:    "kontakt(at)milchbauernhof.de", // Impressum-Format
  name:           "Erich Gehrke",
  betrieb:        "Milchbauernhof Gehrke",
  strasse:        "Ostlandweg 1",
  ort:            "38464 Groß Sisbeck",
};
